module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABKklEQVQ4T6WSwU3DQBBF569zRCISthRl90AHhAoIHbgD3AEWNOAWQgWmE5fgEnxYX3AQVgwKUsgOWhMHO7EPUfY6++b/mT+gMx7abKHUnIiioX5gTt08D5v6IWzBxNM66WtQKGVrVqB+NWwVBdEdE82JOQOQ9cHMHACIiai80nrxB0uZErC3M2jbmDEBVnm8rqqnRrljZwj+mEyut0LMWIjZ92r1chLcNC2Uio7g5XTqMxARUPapgzlz8zzowEspMwd42DIHDLwOblvKdAQ82n/rqnqubdtZjOP4BvB3Oe/jaDlIwBwzEO8cxOfn3F6EPRIQ2dguO3Mbs2AhwqMjOYRPurAGfpcyZKKbwQsjunW1tnv5P8+2vTfPu/jabEZ9UWVl+XlP9NPUfgH1YJlldkVe3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_t3.png
// module id = j/pG
// module chunks = 85